import { handleScrollTo } from '../../DOMUtils';
import history from '../../history';

export const navigate = (href) => () => {
	handleScrollTo(href);
	history.push(`#${href}`, { showPreloader: false, prev: history.location, y: window.scrollY });
};

export const getDaysDiff = (date) => {
	const today = new Date();
	const lastChangeDate = new Date(date);
	return Math.ceil(Math.abs(today.getTime() - lastChangeDate.getTime()) / (1000 * 3600 * 24));
};
